import { ScheduledLiveTaskDTO, ScheduledLiveTaskClient } from "@/Generated/ParticaAPI";

export interface IScheduledTaskService {
	get(titleId: number): Promise<ScheduledLiveTaskDTO[]>;
	save(data: ScheduledLiveTaskDTO): Promise<ScheduledLiveTaskDTO>;
	delete(taskId: ScheduledLiveTaskDTO): Promise<any>;
}

export class ScheduledTaskService implements IScheduledTaskService {
	private svc: ScheduledLiveTaskClient = new ScheduledLiveTaskClient();
	public async get(titleId: number): Promise<ScheduledLiveTaskDTO[]> {
		return await this.svc.getScheduledLiveTasks(titleId);
	}
	public async save(data: ScheduledLiveTaskDTO): Promise<ScheduledLiveTaskDTO> {
		return await this.svc.saveScheduledLiveTask(data);
	}
	public async delete(data: ScheduledLiveTaskDTO): Promise<any> {
		return await this.svc.deleteScheduledLiveTask(data);
	}
}
